import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppSettings } from '../../../shared/app.settings';
import { UserCommonService } from './../../services/user-common.service';
import { UiService } from '../../services/ui.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
})

export class ForgotPasswordComponent implements OnInit {
  @Output() popClose: EventEmitter<any> = new EventEmitter();
  @Output() popSave: EventEmitter<any> = new EventEmitter();
  isEmailInvalid: Boolean;

  forgotPasswordErrors = [
    {
      username: false
    }
  ];
  editforgotForm = new FormGroup({
    username: new FormControl()
  });

  constructor(
    private formBuilder: FormBuilder,
    private commonServices: UserCommonService,
    private uiService: UiService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.isEmailInvalid = false;
    this.editforgotForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.pattern(AppSettings.EMAIL_PATTERN)]],
    });
  }

  closeEditForgot(event) {
    this.editforgotForm.reset();
    this.popClose.emit();
  }

  onBackSign(event) {
    this.editforgotForm.reset();
    this.router.navigate(['signin']);
  }

  changePassword(event) {
    let input;
    let otpEmail;
    let otpPhone;

    const userName = this.editforgotForm.controls.username.value.trim();
    if (userName.match(AppSettings.EMAIL_PATTERN)) {
      otpEmail = userName;
      input = {
        email: userName,
        tenantId: AppSettings.TENANT
      };
    } else if (userName.match(AppSettings.PHONE_PATTERN)) {
      otpPhone = userName;
      input = {
        phoneNum: userName,
        tenantId: AppSettings.TENANT
      };
    } else {
      input = {
        username: userName,
        tenantId: AppSettings.TENANT
      };
    }

    this.commonServices.forgotPassword(input).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
      results.email = otpEmail;
      results.phone = otpPhone;
      setTimeout(() => {
        this.router.navigate(['/otp-verify']);
        this.editforgotForm.reset();
      }, 1200);
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  validateEmail() {
    this.isEmailInvalid = false;
    if (this.editforgotForm.get('username').value) {
      if (!AppSettings.EMAIL_PATTERN.test(this.editforgotForm.get('username').value)) {
        this.isEmailInvalid = true;
      }
    }
  }

}
